<template lang="html">
  <div class="work-list">
    <listItem
      v-for="item in items"
      :user="item"
      :key="item.uid"
      :params="params"
      v-on:userDetail="getUserID"
    ></listItem>
  </div>
</template>

<script>
import listItem from '@/components/user/profile_list'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  updated() {},
  computed: {},
  methods: {
    async getUserID(user) {
      if (!user.uid) return
      this.$$tracker('130201', '20000', 130201, user.workerCode)
      // if (user.source !== 'pop') {
      //     location.href = `${this.$$hostname('shequ')}/bbs/user/${user.uid}`
      // } else {
      location.href = `/v/user/${user.uid}`
      // }
    }
  },
  components: {
    listItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.work-list {
  // margin-top:rem(80px);
  background: #fff;
  padding: 0 rem(15px);
}
</style>
